<template>
  <div>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "login",
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
    }
  },
  mounted() {
    this.microLogin();
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    microLogin() {
      let access_token = this.$route.query.access_token || '';
      if (access_token.length) {
        this.loaderActive = true;
        let config = {
          'AUTHORIZATION': 'Bearer ' + access_token
        };
        sendRequest('get', 'check-token', {}, config)
            .then(response => {
              this.loaderActive = false;
              if (response.success) {
                this.$store.dispatch('saveAuthUser', {
                  'token': access_token,
                });
                this.$router.push({ path: '/dashboard'})
              } else {
                window.location.href = process.env.VUE_APP_MICROSITE_BASE_API;
              }
            })
            .catch(() => {
              this.loaderActive = false;
            });
      } else {
        window.location.href = process.env.VUE_APP_MICROSITE_BASE_API;
      }

    },
  }
};
</script>

<style scoped>

</style>
